export { BaseSection } from './BaseSection/BaseSection';
export { NewsSection } from './NewsSection/NewsSection';
export { default } from './PageLayout';
